import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as department from '../department'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: department.RESOURCE.payload.dimension.partialId,
      partialId: department.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description: 'Is this department part of a subset of interest?',
    isOptional: true,
    name: 'Should Analyze?',
    partialId: PartialId.Standard.create('should_analyze'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
